import { render, staticRenderFns } from "./ImageAttachmentComponent.vue?vue&type=template&id=3f6a164e&"
import script from "./ImageAttachmentComponent.vue?vue&type=script&lang=js&"
export * from "./ImageAttachmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports